/* eslint-disable */
import React, { useRef } from 'react';
import closeSvg from 'src/assets/close.svg';
import ReactModal from 'react-modal';
import {
  CloseIcon,
  Row,
  Label,
  Value,
  ValueGroup,
  Container,
  TitleValue,
  Heading,
  Separator,
} from './invocie-histpory-styles';

const formatDate = (date?: string | Date | null) => {
  if (!date) return '-';

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (Number.isNaN(parsedDate.getTime())) return '-';

  return parsedDate.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

const getChangedFields = (before: any = {}, after: any = {}) => {
  const changes: Array<{
    field: string;
    before: any;
    after: any;
  }> = [];

  const excludedFields = [
    'userId',
    'assignmentId',
    'assignmentName',
    'invoiceNumber',
    'totalHours',
    'clientId',
    'invoiceDate',
  ];

  Object.keys(after).forEach(key => {
    if (excludedFields.includes(key)) {
      return;
    }

    if (before[key] !== after[key]) {
      changes.push({
        field: key,
        before: before[key],
        after: after[key],
      });
    }
  });

  return changes;
};

const formatFieldLabel = (field: string) => {
  return (
    field
      // Add spaces between camelCase words
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      // Normalize underscores and hyphens
      .replace(/[_-]+/g, ' ')
      // Capitalize the first letter of each word
      .replace(/\b\w/g, char => char.toUpperCase())
      .trim()
  );
};

export const InvoiceHistoryModal: React.FC<{
  isOpen: boolean;
  setIsOpen: Function;
  data: any; // optional because first time it's null
}> = ({ isOpen, setIsOpen, data = null }) => {
  const modalRef = useRef(null);

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const formatFieldValue = (field: string, value: any) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const dateFields = ['periodStart', 'periodEnd', 'invoiceDate'];

    if (dateFields.includes(field)) {
      return formatDate(value);
    }

    if (field.toLowerCase() === 'status') {
      return String(value).toUpperCase();
    }

    return value;
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          overflowX: 'auto',
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: '0px auto',
          width: 'max-content',
          minWidth: '550px',
          maxWidth: '720px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      }}
      onRequestClose={handleModalClose}
      // eslint-disable-next-line no-return-assign
      contentRef={(node: any) => (modalRef.current = node)}
    >
      <CloseIcon src={closeSvg} onClick={handleModalClose} />
      {/* <SecurityQuesForm username={username} onSuccess={handleModalClose} /> */}

      <>
        {data?.actionType === 'CREATED' ? (
          <Container>
            {/* Assignment */}
            <Heading>Details</Heading>
            <Separator />
            <Row>
              <Label>Assignment</Label>
              <ValueGroup>
                <Value>Assignment ID - {data.invoice?.assignmentId}</Value>
                <Value>Job Title - {data.invoice?.jobTitle}</Value>
                <Value>Hire Type - {data.invoice?.hireType}</Value>
              </ValueGroup>
            </Row>
            {/* Company */}
            <Row>
              <Label>Company</Label>
              <ValueGroup>
                <Value>{data.invoice?.companyName}</Value>
              </ValueGroup>
            </Row>

            {/* Client */}
            <Row>
              <Label>Client</Label>
              <ValueGroup>
                <Value>{data.invoice?.clientName}</Value>
              </ValueGroup>
            </Row>

            {/* Worker */}
            <Row>
              <Label>Worker</Label>
              <ValueGroup>
                <Value>{data.invoice?.employeeName}</Value>
              </ValueGroup>
            </Row>

            {/* Approvers */}
            <Row>
              <Label>Approvers</Label>
              <ValueGroup>
                <Value>{data?.invoice?.approverName}</Value>
                <Value>{data?.invoice?.coApproverName}</Value>
              </ValueGroup>
            </Row>

            {/* Amounts */}
            <Row>
              <Label>Amounts</Label>
              <ValueGroup>
                <Value>
                  Billable Amount - {data?.invoice?.currency} {data?.invoice?.currency}
                  {data?.invoice?.billableAmount}
                </Value>
                <Value>
                  Submitted Amount - {data?.invoice?.currency} {data?.invoice?.submittedAmount}
                </Value>
                <Value>Total Hours - {data?.invoice?.totalHours}</Value>
              </ValueGroup>
            </Row>

            {/* Rate Info */}
            <Row>
              <Label>Rate Info</Label>
              <ValueGroup>
                <Value>Effective Date - {data?.invoice?.effectiveDate}</Value>

                <TitleValue>Standard</TitleValue>
                <Value>
                  Bill Rate - {data?.invoice?.currency} {data?.invoice?.billRate}
                </Value>
                <Value>
                  Pay Rate - {data?.invoice?.currency} {data?.invoice?.payRate}
                </Value>
                <Value>Markup - {data?.invoice?.rateMarkup}%</Value>

                {/* <TitleValue>Overtime</TitleValue>
                <Value>Bill Rate - {data?.invoice?.currency}{data?.invoice?.overtimeBillRate}</Value>
                <Value>Pay Rate - {data?.invoice?.currency}{data?.invoice?.overtimePayRate}</Value>
                <Value>Markup - {data?.invoice?.overtimeMarkup}%</Value> */}
              </ValueGroup>
            </Row>

            {/* Invoice Dates */}
            <Row>
              <Label>Invoice Start Date</Label>
              <ValueGroup>
                <Value>{data?.invoice?.periodStart}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Invoice End Date</Label>
              <ValueGroup>
                <Value>{data?.invoice?.periodEnd}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Invoice Date</Label>
              <ValueGroup>
                <Value>{data?.invoice?.invoiceDate}</Value>
                <Value>{data?.invoice?.invoiceDate}</Value>
              </ValueGroup>
            </Row>

            {/* Attachments */}
            <Row>
              <Label>Attachments</Label>
              <ValueGroup>
                {data?.invoice?.attachments?.map((attachment: any) => (
                  <Value key={attachment.id}>{attachment.attachmentName}</Value>
                ))}
              </ValueGroup>
            </Row>

            <Row>
              <Label>Version</Label>
              <ValueGroup>
                <Value>{data?.invoice?.version}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Status</Label>
              <ValueGroup>
                <Value>{data?.invoice?.status}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Submitted At</Label>
              <ValueGroup>
                <Value>{formatDate(data?.invoice?.createdAt)}</Value>
              </ValueGroup>
            </Row>
          </Container>
        ) : data?.actionType === 'STATUS_CHANGE' ? (
          <Container>
            <Heading>Details</Heading>
            <Separator />

            <Heading>From</Heading>

            <Row>
              <Label>Status</Label>
              <ValueGroup>
                <Value>{data?.details?.before?.status ?? '-'}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Comment</Label>
              <ValueGroup>
                <Value>{data?.details?.before?.comment ?? '-'}</Value>
              </ValueGroup>
            </Row>

            <Separator />

            <Heading>To</Heading>

            <Row>
              <Label>Status</Label>
              <ValueGroup>
                <Value>{data?.details?.after?.Status ?? '-'}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Changed by</Label>
              <ValueGroup>
                <Value>{data?.details?.after?.['Changed by'] ?? '-'}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Comment</Label>
              <ValueGroup>
                <Value>{data?.details?.after?.Comment ?? '-'}</Value>
              </ValueGroup>
            </Row>
          </Container>
        ) : data?.actionType === 'EDIT' || data?.actionType === 'OVERRIDE' ? (
          // EDIT UI
          <Container>
            <Heading>Details</Heading>
            <Separator />

            {getChangedFields(data?.details?.before, data?.details?.after).map(change => (
              <React.Fragment key={change.field}>
                <Row>
                  <Label>{formatFieldLabel(change.field)}</Label>

                  <ValueGroup>
                    <Value>
                      <strong>Before:</strong> {formatFieldValue(change.field, change.before)}
                    </Value>

                    <Value>
                      <strong>After:</strong> {formatFieldValue(change.field, change.after)}
                    </Value>
                  </ValueGroup>
                </Row>

                <Separator />
              </React.Fragment>
            ))}

            <Row>
              <Label>Comment</Label>

              <ValueGroup>
                <Value>{data?.details?.comment || '-'}</Value>
              </ValueGroup>
            </Row>
          </Container>
        ) : null}
      </>
    </ReactModal>
  );
};
